import { render, staticRenderFns } from "./MarketPreview.vue?vue&type=template&id=953ce3f4&scoped=true"
import script from "./MarketPreview.vue?vue&type=script&lang=js"
export * from "./MarketPreview.vue?vue&type=script&lang=js"
import style0 from "./MarketPreview.vue?vue&type=style&index=0&id=953ce3f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953ce3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('953ce3f4')) {
      api.createRecord('953ce3f4', component.options)
    } else {
      api.reload('953ce3f4', component.options)
    }
    module.hot.accept("./MarketPreview.vue?vue&type=template&id=953ce3f4&scoped=true", function () {
      api.rerender('953ce3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/templateMarket/component/MarketPreview.vue"
export default component.exports